import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMaximize2, FiX, FiPlay, FiExternalLink } = FiIcons;

const FilmGallery = ({ title, category, pageHeading = false }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);

  // Helper to extract YouTube ID info
  const getYouTubeInfo = (id, caption) => ({
    id,
    type: 'video',
    src: `https://img.youtube.com/vi/${id}/maxresdefault.jpg`,
    videoUrl: `https://www.youtube.com/embed/${id}?autoplay=1`,
    caption
  });

  const galleryData = {
    "Tinman": {
      description: "A dedicated surgeon puzzles with the idea that a world wide virus is man made.",
      watchLink: "https://www.primevideo.com/detail/0MZYGX3ASOGG3FEVE0L82SOFA7",
      trailerUrl: "https://www.dropbox.com/scl/fi/urdisylevtk3o5bfbyw9p/Tinman-OFFICIAL-TRAILER-1-4K.mp4?rlkey=hypaequnmwajkxweg5awi00pl&st=y1jb6t28&raw=1",
      images: [
        { id: 'poster', src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568820/tinman-poster_ajgaqw.jpg", caption: "Official Poster" },
        { id: 1, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568821/tinman-red-carpet_n2b5ub.jpg" },
        { id: 2, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568823/tinman_preview_iqebch.png" },
        { id: 3, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568823/tinman_preview_screen_upja6d.png" },
        { id: 4, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568826/tinman-hospital-bed-scene_oqf3lv.jpg" },
        { id: 5, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568820/tinman-meeting2_cibei7.jpg" },
        { id: 6, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568820/tinman-onset_qcmmjp.jpg" },
        { id: 7, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568819/tinman-group-pic_ftisqi.jpg" },
        { id: 8, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568819/tinman-meeting_toigv9.jpg" },
        { id: 9, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568818/tinman-doc-son_zqyf1r.jpg" },
        { id: 10, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568817/tinman-girl-on-hospital-bed_vgmirr.jpg" },
        { id: 11, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568817/tinman-doc-peace_l6mgyj.jpg" },
        { id: 12, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568816/tinman-doc-5ladies_hxa6jk.jpg" },
        { id: 13, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568816/tinman-doc-actor-umbrella_dd37hf.jpg" },
        { id: 14, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568816/tinman-camera-setup_fnjhc9.jpg" },
        { id: 15, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568815/tinman-doc-2crewmembers_vzxzj0.jpg" },
        { id: 16, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568815/tinman-blond-woman_nld7oo.jpg" },
        { id: 17, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774568814/tinman-2-actors_zs3m7v.jpg" }
      ]
    },
    // ... rest of gallery data remains the same
    "The Playground": {
      description: "Where innocence meets terror. A haunting psychological thriller that explores the dark, forgotten echoes of childhood memories.",
      images: [
        { id: 1, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579065/play-magazine-cover_ijcktx.jpg" },
        { id: 2, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579111/64ce9249ded53_play-meeting-white-cups_dm6941.jpg" },
        { id: 3, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579096/play-actor-in-glasses_ayyb7t.jpg" },
        { id: 4, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579081/play-crew-sitting_jr9sly.jpg" },
        { id: 5, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579051/playground-cast_ynmn42.jpg" },
        { id: 6, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579035/64ce930e3419d_play-tripod-meeting_kkvbai.jpg" },
        { id: 7, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579020/64ce911b4f466_play-woman-alone_jozv8l.jpg" },
        { id: 10, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774578961/64ca8a25ac4b9_playground_-cameras-with-guy-at-back_r463fg.jpg" },
        { id: 11, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774578947/64c5906cf1624_playground-cast_qy4qkd.jpg" }
      ]
    },
    "Truth and Fairytales": {
      description: "A raw, visceral deconstruction of grief and survival. Following a devastating personal loss, a psychologist must navigate a gritty reality.",
      images: [
        { id: 1, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579862/truth-and-fairytales-guy-in-the-dark_hdfhwf.jpg" },
        { id: 2, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579846/6480e89003fb9_IMG_0955_tpcraf.jpg" },
        { id: 3, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579830/6480e847c42fb_IMG_0956_gj0vcp.jpg" },
        { id: 4, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579799/64c593b0e3659_truth-and-fairytales-woman-in-black_muq9fm.jpg" },
        { id: 5, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774579815/6480e81f9460d_IMG_0957_dbtnt7.jpg" }
      ]
    },
    "The Festivals": {
      description: "From the red carpets of Cannes to the indie spirit of Sundance. Explore the award-winning journey of Sandstorm Flix.",
      images: [
        { id: 1, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774577647/6484dc164cc0f_cannes-sign-lights_uzz48s.jpg" },
        { id: 2, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774577704/66956fe8c0bcb_IMG_0836_zeguxi.jpg" },
        { id: 3, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774577719/cannes-doc-with-couple_itfcch.jpg" },
        { id: 4, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774577690/66956fc93b2e6_IMG_0035_oqwr8a.jpg" },
        { id: 5, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774577662/6484dc7654dd0_doc-red-umbrella_td8bm4.jpg" },
        { id: 6, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774577633/64c58f0d804c6_cannes-doc-with-3-ladies_pz1sql.jpg" },
        { id: 7, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774577605/64bae0c24fc28_cannes-grey-group.jpg_qqszwx.jpg" },
        { id: 8, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774577619/64c5a07ece789_red-carpet-lady-with-doc_uagjzh.jpg" },
        { id: 9, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774577676/6484dee1bddf6tinymcegroup_20pic_20in_20cannes_z2yndr.jpg" },
        { id: 10, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774638629/who-we-are-doc-with-2-cool-awards_gtkvvp.jpg" },
        { id: 11, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774638626/who-we-are-doc-with-2-florence-film-awards_pcmmvb.jpg" },
        { id: 12, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774638624/64cb11df54c87_we-are_-doc-with-award-in-tshirt-450px_gw1e4z.jpg" },
        { id: 13, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774638622/64cb0f8dc249b_we-are-do-alone-aetna-red-carpet-450px_vz4y34.jpg" }
      ]
    },
    "YouTube Shorts": {
      description: "Bite-sized cinema, massive impact. Discover a collection of visionary micro-narratives curated by Kevin V. Tudor.",
      images: [
        getYouTubeInfo("fAAAvBXLfHA", "Tinman"),
        getYouTubeInfo("Xep3pxe7K4s", "Truth & Fairytales"),
        getYouTubeInfo("RjCPKLOHNhU", "Widow Maker"),
        getYouTubeInfo("0XOYFy5HI5Q", "Doctor’s Orders"),
        getYouTubeInfo("BhqsrY_4JmU", "Forever Now"),
        getYouTubeInfo("Df9l-cPfPVw", "Hiatus"),
        getYouTubeInfo("G9Q4l9pbVbY", "Woman of Convenience"),
        getYouTubeInfo("AFF1MI7r4Nk", "The Visit"),
        getYouTubeInfo("IRSIUJgGG_Q", "The Dreamcatcher"),
        getYouTubeInfo("lEBKTu3tq4o", "Silent Observer I"),
        getYouTubeInfo("kEnssXZISxA", "Silent Observer II")
      ]
    },
    "In Print": {
      description: "From headlines to high-fashion. See how Sandstorm Flix and Kevin V. Tudor are making waves in leading global publications.",
      images: [
        { id: 1, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774646761/sandstorm_in_print_1_sk8nsc.png" },
        { id: 2, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774646765/sandstorm_in_print_2_id63zt.png" },
        { id: 3, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774646765/sandstorm_in_print_3_dio35w.png" },
        { id: 4, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774646765/sandstorm_in_print_5_keoaqg.png" },
        { id: 5, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774646764/sandstorm_in_print_4_yxcg68.png" }
      ]
    },
    "The Team": {
      description: "The architects of imagination. Meet the creative minds who bring our cinematic visions to life at Sandstorm Flix.",
      images: [
        { id: 1, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632758/64ca86591f4a5_support_-doc-with-guy-in-tux_yv0xwp.jpg" },
        { id: 2, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632758/64cb070fa2740_support-doc-with-guy_e0kjr8.jpg" },
        { id: 3, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632759/64db928a1a143_sand-piano-girl-replacement_a1g7pb.jpg" },
        { id: 4, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632758/64c59532d314b_sand-group-in-grey-and-black_v3gvlq.jpg" },
        { id: 5, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632758/64cb05103f398_support-doc-and-guy-with-flower-500px_dpn0qv.jpg" },
        { id: 6, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632757/who-we-are-group-in-yellow-sofa_pmk6lb.jpg" },
        { id: 7, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632757/64cb05d46dd35_support-doc-with-girl_zpx1k6.jpg" },
        { id: 8, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632757/64d129e8dbd55_support-doc-and-group-8-7-23_etxjml.jpg" },
        { id: 9, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632757/who-we-are-doc-and-daughter_eosywm.jpg" },
        { id: 10, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632756/who-we-are-doc-with-adorable-bane_qvvicd.jpg" },
        { id: 11, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632757/66954cad6b16a_FullSizeRender-2_bslpdx.jpg" },
        { id: 12, src: "https://res.cloudinary.com/dwumujtpu/image/upload/v1774632757/669572f26eb7a_IMG_5450_ezgcqi.jpg" }
      ]
    }
  };

  const project = galleryData[title] || { description: "", images: [] };
  const isShorts = title === "YouTube Shorts";
  const Heading = pageHeading ? 'h1' : 'h2';

  return (
    <section className="py-24 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-16 text-center"
        >
          <span className="text-accent-orange font-bold tracking-[0.4em] uppercase text-[10px] block mb-4 italic">{category}</span>
          <Heading className="text-5xl md:text-7xl font-serif font-bold text-black uppercase tracking-tight mb-4">{title}</Heading>
          
          <div className="flex flex-wrap justify-center gap-8 mb-8">
            {project.watchLink && (
              <motion.a 
                href={project.watchLink}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
                className="inline-flex items-center gap-2 text-accent-orange font-black uppercase tracking-[0.2em] text-sm md:text-base hover:underline border-b-2 border-transparent hover:border-accent-orange transition-all duration-300"
              >
                Watch {title} on Amazon Prime
                <SafeIcon icon={FiExternalLink} className="w-4 h-4" />
              </motion.a>
            )}

            {project.trailerUrl && (
              <motion.button 
                onClick={() => setSelectedItem({ videoUrl: project.trailerUrl, type: 'video', isDirect: true, caption: `${title} Official Trailer` })}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.4 }}
                className="inline-flex items-center gap-2 text-black font-black uppercase tracking-[0.2em] text-sm md:text-base hover:text-accent-orange transition-all duration-300 border-b-2 border-transparent hover:border-accent-orange"
              >
                Watch Official Trailer
                <SafeIcon icon={FiPlay} className="w-4 h-4" />
              </motion.button>
            )}
          </div>

          <div className="w-20 h-1 bg-accent-orange mx-auto mb-8"></div>
          <p className="max-w-2xl mx-auto text-black/60 text-lg leading-relaxed font-medium mb-12">
            {project.description}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {project.images.map((item, idx) => (
            <motion.div
              key={item.id || idx}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.05 }}
              className="group relative cursor-pointer"
              onMouseEnter={() => setHoveredId(item.id || idx)}
              onMouseLeave={() => setHoveredId(null)}
              onClick={() => setSelectedItem(item)}
            >
              <div 
                className={`rounded-[32px] overflow-hidden bg-[#242424] border border-zinc-200 transition-all duration-700 group-hover:shadow-2xl flex items-center justify-center relative 
                  ${item.id === 'poster' ? 'aspect-[2/3] md:aspect-[16/9]' : 'aspect-[16/9]'}`}
              >
                {isShorts ? (
                  <div className="w-full h-full flex flex-col items-center justify-center p-8 text-center bg-[#242424]">
                    <h3 className="text-2xl md:text-3xl font-serif font-bold uppercase tracking-[0.1em] leading-tight transition-all duration-500 bg-gradient-to-br from-[#FF5C00] via-[#FF8A00] to-[#FF5C00] bg-clip-text text-transparent group-hover:scale-110">
                      {item.caption}
                    </h3>
                  </div>
                ) : (
                  <img 
                    src={item.src} 
                    alt={item.caption ? `${title}: ${item.caption}` : `${title} production still ${idx + 1}`}
                    loading="lazy"
                    className={`w-full h-full ${item.id === 'poster' ? 'object-contain md:object-cover' : 'object-cover'} grayscale transition-all duration-1000 group-hover:scale-110 group-hover:grayscale-0 rounded-[32px]`}
                  />
                )}
                
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-all duration-500 flex items-center justify-center rounded-[32px]">
                  <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center text-white">
                    <SafeIcon icon={isShorts ? FiPlay : FiMaximize2} className="w-6 h-6" />
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {selectedItem && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-2xl flex items-center justify-center p-4 md:p-12"
            onClick={() => setSelectedItem(null)}
          >
            {/* Global Close Button - Always fixed to top right of screen */}
            <button 
              onClick={(e) => {
                e.stopPropagation();
                setSelectedItem(null);
              }}
              className="fixed top-6 right-6 md:top-10 md:right-10 w-12 h-12 bg-accent-orange text-white rounded-full flex items-center justify-center shadow-2xl z-[200] border-2 border-white/20 active:scale-90 transition-transform hover:bg-white hover:text-accent-orange"
              aria-label="Close lightbox"
            >
              <SafeIcon icon={FiX} className="w-6 h-6 md:w-8 md:h-8" />
            </button>
            
            <motion.div 
              initial={{ scale: 0.9, opacity: 0, y: 30 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 30 }}
              className="max-w-7xl w-full h-auto max-h-[85vh] md:max-h-none flex items-center justify-center relative"
              onClick={e => e.stopPropagation()}
            >
              {selectedItem.type === 'video' ? (
                <div className="w-full aspect-video">
                  {selectedItem.isDirect ? (
                    <video 
                      src={selectedItem.videoUrl} 
                      controls 
                      autoPlay 
                      className="w-full h-full rounded-[32px] shadow-2xl"
                    />
                  ) : (
                    <iframe
                      src={selectedItem.videoUrl}
                      className="w-full h-full rounded-[32px] shadow-2xl border-none"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  )}
                </div>
              ) : (
                <img 
                  src={selectedItem.src} 
                  className="w-full h-auto max-h-[80vh] md:max-h-[90vh] object-contain rounded-[24px] md:rounded-[48px] shadow-2xl transition-transform duration-500" 
                  alt={selectedItem.caption ? `${title}: ${selectedItem.caption}` : `${title} production still ${selectedItem.id || 'preview'}`}
                />
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default FilmGallery;